import { useRewardsSuppressed } from '~/composables/unified/useRewardsSuppressed';
import { useConfigStore } from '~/stores/config';

/**
 * Declarative twin of `regionAvailable` for the schools door (CP-11267): a page that declares
 * `unavailableOnSchools` in its meta is redirected away on schools-product clusters — rewards,
 * cash-outs and prize-draw surfaces structurally do not exist there. A rewards surface also turns
 * away every viewer whose rewards are suppressed, such as a schools-labelled account on the public
 * host. One meta line per page, one redirect implementation.
 */
export default defineNuxtRouteMiddleware((to) => {
  const unavailableOnSchools = to.meta.unavailableOnSchools;

  if (!unavailableOnSchools) {
    return;
  }

  const unavailable = unavailableOnSchools.rewardsSurface
    ? useRewardsSuppressed().value
    : useConfigStore().isSchoolsCluster;

  if (!unavailable) {
    return;
  }

  return navigateTo(clusterRedirectPath(unavailableOnSchools.navigateToLink ?? '/'), { replace: true });
});
